import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {atOutline, atSharp} from "ionicons/icons"

interface props {
    active?: boolean
}

const ListItemButtonAlertEmail: React.FC<props> = ({ active }) => {

    const { t } = useTranslation()
        , [presentAlert] = useIonAlert()
        , translationKey: string = "people.alerts." + (active ? 'email' : 'no_email')

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message', { itemType: t('people.title_item').toLowerCase() }),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    return (
        <IonButton color={active ? 'medium' : 'light'} fill="clear" title={t(translationKey + '.header').toString()}
                   onClick={(e) => alertMessage(e)}>
            <IonIcon slot="icon-only" ios={atOutline} md={atSharp} />
        </IonButton>
    )
}

export default ListItemButtonAlertEmail